import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HelpCircle, Mail } from 'lucide-react';

const SUPPORT_EMAIL = 'support@quote2cart.app';

const Help = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailto = `mailto:${SUPPORT_EMAIL}?subject=Quote2Cart%20Support%20from%20${encodeURIComponent(form.name)}&body=${encodeURIComponent(form.message + '\n\nFrom: ' + form.email)}`;
    window.location.href = mailto;
  };

  const backendBase = (import.meta.env.VITE_BACKEND_URL || '').replace(/\/$/, '');
  const widgetLoaderUrl = backendBase
    ? `${backendBase}/widget/js/quote2cart-ecwid-loader.js`
    : '/widget/js/quote2cart-ecwid-loader.js';

  const cardBase = {
    background: '#fff',
    borderRadius: '16px',
    padding: '1.5rem',
    height: '100%',
    border: '1px solid #e5e7eb',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
  };

  return (
    <div className="py-4" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)', borderRadius: 16 }}>
      <div className="container-fluid px-4">
        <div className="text-center mb-4">
          <div
            className="d-inline-flex align-items-center justify-content-center mb-3"
            style={{
              width: 64,
              height: 64,
              background: 'linear-gradient(135deg, var(--app-primary) 0%, var(--app-primary-dark) 100%)',
              borderRadius: 16,
            }}
          >
            <HelpCircle size={32} color="#fff" />
          </div>
          <h2 className="h4 mb-2">{t('help.title')}</h2>
          <p className="text-muted">{t('help.subtitle')}</p>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div style={cardBase}>
              <h3 className="h6 mb-3">{t('help.storefrontWidget')}</h3>
              <p className="text-muted small">
                {t('help.widgetDescBefore')} <code>customJsUrl</code> {t('help.widgetDescAfter')}
              </p>
              <code className="small d-block text-break mb-2">{widgetLoaderUrl}</code>
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={() => {
                  navigator.clipboard?.writeText(widgetLoaderUrl);
                }}
              >
                {t('help.copyLoaderUrl')}
              </button>
            </div>
          </div>

          <div className="col-md-6">
            <div style={cardBase}>
              <h3 className="h6 mb-3">{t('help.contact')}</h3>
              <p className="text-muted small mb-3">{t('help.contactDesc')}</p>
              <a href={`mailto:${SUPPORT_EMAIL}`} className="d-inline-flex align-items-center gap-2 text-decoration-none">
                <Mail size={16} />
                {SUPPORT_EMAIL}
              </a>
            </div>
          </div>

          <div className="col-12">
            <div style={cardBase}>
              <h3 className="h6 mb-3">{t('help.sendMessage')}</h3>
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <input className="form-control" name="name" placeholder={t('help.name')} value={form.name} onChange={handleChange} required />
                  </div>
                  <div className="col-md-6">
                    <input className="form-control" type="email" name="email" placeholder={t('help.email')} value={form.email} onChange={handleChange} required />
                  </div>
                  <div className="col-12">
                    <textarea className="form-control" name="message" rows={4} placeholder={t('help.message')} value={form.message} onChange={handleChange} required />
                  </div>
                  <div className="col-12">
                    <button type="submit" className="btn btn-primary">{t('help.send')}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
